// 新規契約作成
$(() => {
    if (document.getElementById('partner-contract-form') != null) {
		setupRelatedContractsList();
        deleteFiles();
        cancelFiles();
        addFiles();
	}

    if (document.getElementById('partner-contract-edit-biller-form') != null) {
        setDefaultBillerSetting();
        changeBillerSetting();
    }
});

// 契約詳細-請求情報編集-請求情報プルダウンのイベント
function changeBillerSetting() {
    $('.js-biller-select').on('change', function (e) {
        $('.partner-biller-setting-wrap').removeClass('show-biller').addClass('hide-biller');
        $('#partner-biller-setting-' + $(this).val()).removeClass('hide-biller').addClass('show-biller');
    });
}
function setDefaultBillerSetting() {
    $('#partner-biller-setting-' + $('.js-biller-select').val()).removeClass('hide-biller').addClass('show-biller');
}

// 関連契約リスト構築
function setupRelatedContractsList() {
	var element = $('.js-select-contract');
	setupContractSelector(element, '/partner/contract/findContracts');

	const relatedContracts = $('#relatedContracts').val();
	if (relatedContracts) {
		const template = $('#related-list-item');
		relatedContracts.split(',').forEach((param) => {
			let data = param.split(':');
			const item = createRelatedItem(data[0], data[1], data[2]);
			$('.js-related-list').append(item);
		});
	}

	$('.js-add-related-contract').on('click', function(e) {
		$.ajax({
			url: '/partner/contract/getContract',
			type: 'POST',
			data: { id: $('#contractSelector').val() },
			dataType: 'json',
			timespan: 1000
		}).done(function(data, textStatus, jqXHR) {
			if (data.id) {
				const item = createRelatedItem(data.id, data.no, data.name);
				$('.js-related-list').append(item);
				let values = $('#relatedContracts').val().split(',');
				const result = values.find(item => item.split(':')[0] == data.id);
				if (!result) {
					values.push(data.id + ':' + data.no + ':' + data.name);
					$('#relatedContracts').val(values.join(','));
				}
			}
		}).fail(function(jqXHR, textStatus, errorThrown ) {
		}).always(function(){
		});
	});

	$(document).on("click", '.js-remove-related-contract', function(e) {
		e.preventDefault();
		let target = $(this).closest('.js-contract-item');
		if (target.length) {
			let id = target.data('id');
			let values = $('#relatedContracts').val().split(',');
			const results = values.filter(item => item.indexOf(id + ':') != 0);
			$('#relatedContracts').val(results.join(','));
			target.remove();
		}
	});
}

// 関連契約アイテム作成
function setupContractSelector(element, url) {
	element.select2({
		tags: true,
		placeholder: '契約名を入力して下さい',
		dropdownAutoWidth: true,
		width: 'resolve',
		allowClear: true,
		ajax: {
			type: 'POST',
			async: true,
            url: url,
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},
			data: function (params) {
				var query = {
					search: params.term,
				}
				return query;
			},
			minimumInputLength: 2,
			delay: 200,
			cache: true,
			processResults: function(data) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            id: item.id,
                            text: item.name,
                        }
                    })
                }
            }
		}
	});
	var params = element.data('init');
	if (params) {
		let values = [];
		params.split(',').filter(item => {
			let val = item.split(':');
			var opt = new Option(val[1], val[0], false, false);
			element.append(opt);
			values.push(val[0]);
		});
		element.val(values).trigger('change');
	}
}

// 関連契約アイテム作成
function createRelatedItem(id, no, name) {
	const content = $('#related-list-item')[0].content;
	const fragment = document.createDocumentFragment();
	let clone = document.importNode(content, true);
	let item = $('.js-contract-item', clone);
	item.attr('data-id', id);
	item.children('.js-contract-no').text(no);
	item.children('.js-contract-name').text(name);
	fragment.appendChild(clone);
	return fragment;
}

/**
 * ファイル削除処理
 */
function deleteFiles() {
    // 見た目上消すだけ、実際の削除は保存の後
    $(document).on("click", '.js-file-delete', function(e) {
        var id = $(this).data('id');
        console.log(id);
        $('#form').append('<input name="deleteFile[]" type="hidden" value="'+ id + '" />');
        $('#file_'+id).remove();
    });
}

/**
 * ファイル追加キャンセル処理
 */
function cancelFiles() {
    $(document).on("click", '.js-file-cancel', function(e) {
        var id = $(this).data('id');
        $('#input_'+id).remove();
        $(this).parent().remove();
    });
}

/**
 * ファイル追加
 */
function addFiles() {
    $(document).on("input", '.js-file-add', function(e) {
        var file_name = $(this).prop('files')[0].name;
        var file_id = $(this).data('id') + 1;

        $(this).css('display', 'none');
        $(this).attr('id', 'input_' + file_id);

        $('#inputFiles').append('<input id="file" type="file" class="js-file-add form-control-file border rounded w-75" name="file[]" data-id="'+ file_id +'">');

        var new_file = $('<div class="col-3" id="'+ file_id +'">').appendTo('#files');
        new_file.append('<span class="fas fa-tag fa-2x" id="cheng-status-span"></span>');
        new_file.append(file_name);
        new_file.append('<a style="font-size:2em" class="js-file-cancel" data-id="' + file_id + '">×</a>');
    });
}
